import { render, staticRenderFns } from "./Listbox.vue?vue&type=template&id=2b3d6f38"
import script from "./Listbox.vue?vue&type=script&lang=js"
export * from "./Listbox.vue?vue&type=script&lang=js"
import style0 from "./Listbox.vue?vue&type=style&index=0&id=2b3d6f38&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QCheckbox,QSpinner,QBtn});
